module.exports = {
  'AstralSituationRecord.mgmtTitle': 'Gestione Eventi',
  'AstralSituationRecord.new': 'Nuovo',
  'AstralSituationRecord.modify': 'Modifica',
  'AstralSituationRecord.clone': 'Duplica',
  'AstralSituationRecord.close': 'Chiudi',
  'AstralSituationRecord.newEvent': 'Nuovo evento',
  'AstralSituationRecord.duplicateEvent': 'Duplica evento',
  'AstralSituationRecord.eventMgmt': 'Gestione evento',
  'AstralSituationRecord.management': 'Gestione',
  'AstralSituationRecord.search': 'Ricerca',
  'AstralSituationRecord.filter': 'Filtri di ricerca',
  'AstralSituationRecord.event': 'Evento',
  'AstralSituationRecord.events': 'Eventi',
  'AstralSituationRecord.title': 'Titolo',
  'AstralSituationRecord.description': 'Descrizione',
  'AstralSituationRecord.type': 'Tipo',
  'AstralSituationRecord.eventType': 'Tipo evento',
  'AstralSituationRecord.list': 'Lista',
  'AstralSituationRecord.save': 'Salva',
  'AstralSituationRecord.cancel': 'Annulla',
  'AstralSituationRecord.delete': 'Elimina',
  'AstralSituationRecord.error': 'ERRORE',
  'AstralSituationRecord.noResultFound': 'Nessun risultato trovato',
  'AstralSituationRecord.saveSuccess': 'Salvataggio completato con successo',
  'AstralSituationRecord.deleteSuccess':
    'Cancellazione completata con successo',
  'AstralSituationRecord.id': 'Id',
  'AstralSituationRecord.severity': 'Gravità',
  'AstralSituationRecord.version': 'Versione',
  'AstralSituationRecord.capacityRemainig': 'Capacità strada rimanente',
  'AstralSituationRecord.numberOfLanesRestricted': 'Numero di corsie limitate',
  'AstralSituationRecord.numberOfOperationalLanes':
    'Numero di corsie operative',
  'AstralSituationRecord.originalNumberOfLanes': 'Numero originale di corsie',
  'AstralSituationRecord.residualRoadWidth': 'Larghezza strada residua',
  'AstralSituationRecord.validityStatus': 'Validità',
  'AstralSituationRecord.probabilityOfOccurrence': 'Probabilità',
  'AstralSituationRecord.confidentiality': 'Confidenzialità',
  'AstralSituationRecord.region': 'Regione',
  'AstralSituationRecord.province': 'Provincia',
  'AstralSituationRecord.cause': 'Causa',
  'AstralSituationRecord.source': 'Fonte',
  'AstralSituationRecord.sources': 'Fonti',
  'AstralSituationRecord.from': 'Da',
  'AstralSituationRecord.to': 'A',
  'AstralSituationRecord.validityPeriods': 'Periodi di validità',
  'AstralSituationRecord.validityPeriod': 'Periodo di validità',
  'AstralSituationRecord.newValidityPeriod': 'Nuovo periodo di validità',
  'AstralSituationRecord.comments': 'Commenti',
  'AstralSituationRecord.comment': 'Commento',
  'AstralSituationRecord.operatorActionOrigin': 'Origine azione operatore',
  'AstralSituationRecord.operatorActionStatus': 'Stato azione operatore',
  'AstralSituationRecord.mobilityType': 'Tipo mobilità',
  'AstralSituationRecord.maintenanceVehicleActions':
    'Azioni veicoli di manutenzione',
  'AstralSituationRecord.maintenanceVehicleAction':
    'Azione veicoli di manutenzione',
  'AstralSituationRecord.equipmentOrSystemFaultType':
    'Tipo errore apparecchiatura o di sistema',
  'AstralSituationRecord.faultyEquipmentOrSystemType':
    'Tipo apparecchiatura o sistema',
  'AstralSituationRecord.abnormalTrafficType': 'Tipo traffico anomalo',
  'AstralSituationRecord.queueLength': 'Lunghezza coda',
  'AstralSituationRecord.trafficFlowCharacteristics':
    'Caratteristiche flusso traffico',
  'AstralSituationRecord.trafficTrendType': 'Tipo trend traffico',
  'AstralSituationRecord.obstructionType': 'Tipo ostruzione',
  'AstralSituationRecord.environmentalObstructionType':
    'Tipo ostruzione ambientale',
  'AstralSituationRecord.infrastructureDamageType': 'Tipo danno infrastrutture',
  'AstralSituationRecord.animalPresenceType': 'Tipo presenza animali',
  'AstralSituationRecord.vehicleObstructionType':
    'Tipo ostruzione causa veicoli',
  'AstralSituationRecord.authorityOperationType':
    'Tipo operazione delle autorita',
  'AstralSituationRecord.disturbanceActivityType': 'Tipo attivita di disturbo',
  'AstralSituationRecord.nonWeatherRelatedRoadConditionType': 'Tipo condizione',
  'AstralSituationRecord.weatherRelatedRoadConditionType': 'Tipo condizione',
  'AstralSituationRecord.poorEnvironmentType': 'Tipo condizione',
  'AstralSituationRecord.constructionWorkType': 'Tipo lavori di costruzione',
  'AstralSituationRecord.roadMaintenanceType': 'Tipo manutenzione stradale',
  'AstralSituationRecord.generalNetworkManagementType':
    'Tipo gestione generale rete stradale',
  'AstralSituationRecord.speedManagementType': 'Tipo gestione velocità',
  'AstralSituationRecord.temporarySpeedLimit': 'Limite di velocità temporaneo',
  'AstralSituationRecord.winterEquipmentManagementType':
    'Tipo attrezzatura invernale',
  'AstralSituationRecord.generalInstructionToRoadUsersType': 'Tipo istruzione',
  'AstralSituationRecord.roadOrCarriagewayOrLaneManagementType':
    'Tipo di gestione stradale o carreggiata o corsia',
  'AstralSituationRecord.roadsideServiceDisruptionType':
    'Tipo di interruzione del servizio di stradale',
  'AstralSituationRecord.roadOperatorServiceDisruptionType':
    'Tipo di interruzione del servizio degli operatori stradali',
  'AstralSituationRecord.accidentType': 'Tipo incidente',
  'AstralSituationRecord.vehiclesInvolved': 'Veicoli coinvolti',
  'AstralSituationRecord.listOfCauses': 'Lista cause',
  'AstralSituationRecord.prevEvent': 'Evento precedente',
  'AstralSituationRecord.NotNull': 'Il campo non puo essere nullo',
  'AstralSituationRecord.NotEmpty': 'Il campo non puo essere vuoto',
  'AstralSituationRecord.Min': "Il valore e' minore del minimo consentito",
  'AstralSituationRecord.Max': "Il valore e' maggiore del massimo consentito",
  'AstralSituationRecord.SituationRecordValidityPeriodValid':
    "Lista non valida: non può essere vuota e solo l'ultimo periodo può avere la data fine vuota",
  'AstralSituationRecord.ValidityPeriodDatesValid':
    'Periodo di validita non valido',
  'AstralSituationRecord.creationDate': 'Data creazione',
  'AstralSituationRecord.totItems': 'Elementi totali',
  'AstralSituationRecord.pagination': 'Paginazione',
  'AstralSituationRecord.itemsPerPage': 'Elementi per pagina',
  'AstralSituationRecord.all': 'Tutti',
  'AstralSituationRecord.csvDownload': 'CSV download',
  'AstralSituationRecord.eventSearch': 'Ricerca eventi',
  'AstralSituationRecord.notValidParameter': 'Parametro non valido',
  'AstralSituationRecord.of': 'del',
  'AstralSituationRecord.dashboard': 'Dashboard',
  'AstralSituationRecord.map': 'Mappa',
  'AstralSituationRecord.select': 'Selezionare',
  'AstralSituationRecord.ok': 'Ok',
  'AstralSituationRecord.attention': 'Attenzione',
  'AstralSituationRecord.deleteItemQuest': "Cancellare l'oggetto corrente?",
  'AstralSituationRecord.back': 'Indietro',
  'AstralSituationRecord.sourceList': 'Lista fonti',
  'AstralSituationRecord.date': 'Data',
  'AstralSituationRecord.reliable': 'Affidabile',
  'AstralSituationRecord.reset': 'Reset',
  'AstralSituationRecord.newSource': 'Nuova fonte',
  'AstralSituationRecord.sourceMgmt': 'Gestione fonte',
  'AstralSituationRecord.location': 'Posizione',
  'AstralSituationRecord.actionOrigin': 'Origine azione',
  'AstralSituationRecord.animalAlive': 'Animale vivo',
  'AstralSituationRecord.Error.sourceDelExistingSituationRecord':
    'Impossibile cancellare la fonte selezionata. Esistono degli eventi collegati in archivio',
  'AstralSituationRecord.Error.situationRecordDelExistingSituationRecord':
    "Impossibile cancellare l'evento selezionato. Esistono degli eventi collegati in archivio",
  'AstralSituationRecord.notSavedChanges': 'Salvare le modifiche apportate?',
  'AstralSituationRecord.yes': 'Si',
  'AstralSituationRecord.no': 'No',
  'AstralSituationRecord.complianceOption': 'Opzione di conformità',
  'AstralSituationRecord.automaticallyInitiated': 'Automaticamente avviato',
  'AstralSituationRecord.error.reloadPage':
    'Errore sul server. Si prega di riprovare piu tardi',
  'AstralSituationRecord.error.expiredSession': 'Sessione scaduta',
  'AstralSituationRecord.error.multipleObjOnMap':
    'Sulla mappa sono stati creati elementi di diverso tipo. Selezionare dei punti oppure un percorso',
  'AstralSituationRecord.error.noObjOnMap':
    'Selezionare una location sulla mappa (punti o percorso)',
  'AstralSituationRecord.selectedFilters': 'Filtri selezionati',
  'AstralSituationRecord.cotral': 'Fermate bus regionali COTRAL',
  'AstralSituationRecord.atac': 'Fermate bus ATAC',
  'AstralSituationRecord.ferrovie': 'Stazioni ferrovie dello stato',
  'AstralSituationRecord.aeroporti1':
    'Aeroporti per voli nazionali o internazionali',
  'AstralSituationRecord.aeroporti2': 'Altri aeroporti',
  'AstralSituationRecord.porti1': 'Porti per rotte nazionali e internazionali',
  'AstralSituationRecord.porti2': 'Porti per rotte regionali',
  'AstralSituationRecord.porti3': 'Altri porti',
  'AstralSituationRecord.traffico': 'Traffico',
  'AstralSituationRecord.transit': 'Transito',
  'AstralSituationRecord.meteo': 'Meteo',
  'AstralSituationRecord.telecamereAstraL': 'Telecamere AstraL',
  'AstralSituationRecord.telecamereAutostrade':
    "Telecamere Autostrade per l'Italia",
  'AstralSituationRecord.mapMenuButton': 'Menu layer',
  'AstralSituationRecord.publicSiteEvidence':
    'In evidenza sul sito web pubblico',
  'AstralSituationRecord.publicSiteEvidence2': 'Evid.',
  'AstralSituationRecord.title': 'Titolo',
  'AstralSituationRecord.isSystem': 'Di sistema',
  'AstralSituationRecord.titleDescription': 'Titolo/Descrizione',
  'AstralSituationRecord.data': 'Dati',
  'AstralSituationRecord.otherInfo': 'Altre informazioni',
  'AstralSituationRecord.attachments': 'Allegati',
  'AstralSituationRecord.selectFile': 'Seleziona file',
  'AstralSituationRecord.newAttachment': 'Nuovo allegato',
  'AstralSituationRecord.delAttachment': 'Rimuovi allegato',
  'AstralSituationRecord.downloadAttachment': 'Scarica allegato',
  'AstralSituationRecord.dragFile': 'Trascina file',
  'AstralSituationRecord.newAttachmentError':
    "Errore nel salvataggio dell'allegato ",
  'AstralSituationRecord.delAttachmentError':
    "Errore nella cancellazione dell'allegato ",
  'AstralSituationRecord.validationErrors': 'Errori di validazione dati',
  'AstralSituationRecord.saveAsTemplate': 'Salva come modello',
  'AstralSituationRecord.templateName': 'Nome modello',
  'AstralSituationRecord.notValidTemplateName': 'Nome modello non valido',
  'AstralSituationRecord.templates': 'Modelli',
  'AstralSituationRecord.keywords': 'Etichette',
  'AstralSituationRecord.channels': 'Canali',
  'AstralSituationRecord.channel': 'Canale',
  'AstralSituationRecord.channel.is-public': 'Visibile',
  'AstralSituationRecord.channel.actions': 'Azioni',
  'AstralSituationRecord.publicSite': 'Sito pubblico',
  'AstralSituationRecord.selectOneOrMoreKeywordsHolding':
    'Etichette (seleziona una o più etichette tenendo premuto il tasto CTRL/CMD)',
  'AstralSituationRecord.carousel': 'Carosello',
  'AstralSituationRecord.newsBullettin': 'Media Promozionali',
  'AstralSituationRecord.templateList': 'Lista modelli',
  'AstralSituationRecord.createFromTemplate': 'Crea evento da modello',
  'AstralSituationRecord.name': 'Nome',
  'AstralSituationRecord.templateMgmt': 'Gestione modello',
  'AstralSituationRecord.saveEvent': 'Salva evento',
  'AstralSituationRecord.templateSearch': 'Ricerca modelli',
  'AstralSituationRecord.valid': 'Valido',
  'AstralSituationRecord.public': 'Pubbl.',
  'AstralSituationRecord.createdBy2': 'Creato da',
  'AstralSituationRecord.updatedBy2': 'Agg. da',
  'AstralSituationRecord.updatedDate2': 'Data agg.',
  'AstralSituationRecord.creationDate2': 'Data creaz.',
  'AstralSituationRecord.createdBy': 'Creato da',
  'AstralSituationRecord.updatedBy': 'Aggiornato da',
  'AstralSituationRecord.updatedDate': 'Data aggiornamento',
  'AstralSituationRecord.isValid': 'Solo eventi validi',
  'AstralSituationRecord.createdUpdateDate': 'Data creaz./agg',
  'AstralSituationRecord.createdUpdateBy': 'Creato/aggiornato da',
  'AstralSituationRecord.update': 'Aggiorna',
  'AstralSituationRecord.broadcast': 'Pubblica',
  'AstralSituationRecord.future': 'Futuro',
  'AstralSituationRecord.createdUpdateDateExt': 'Data creazione/aggiornamento',
  'AstralSituationRecord.publicExt': 'Evento pubblico',
  'AstralSituationRecord.validExt': 'Evento valido',
  'AstralSituationRecord.futureExt': 'Evento futuro',
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/languages/it.js
// module id = 293
// module chunks = 0